import { getCookie } from 'helpers/VanillaCookie';
/**
 * FlowModel reflects Flow.php
 */
export const FLOW_TYPE = Object.freeze({
    DEFAULT: 'f-upsell',
    LIVE_TV: 'f-livetv',
    GIFT: 'f-gift',
    EDU: 'f-edu',
    SIGNIN: 'f-signin',
    CBS_SPORTS: 'cbssports',
    OAUTH_SHOWTIME: 'oauth_showtime',
    AARP: 'aarp',
    AGNOSTIC_RENDEZVOUS: 'agnostic-rendezvous',
    AGNOSTIC_RENDEZVOUS_SIGN_IN_ONLY: 'agnostic-rendezvous-sign-in-only',
    AMAZON: 'amazon',
    APPLE: 'apple',
    SHOWTIME: 'showtime',
    SPORTSLINE: 'sportsline',
    TWENTY_FOUR_SEVEN_SPORTS: '247sports',
    WALMARTPLUS: 'walmartplus',
    DELTA: 'delta',
    FETCH: 'fetch',
    VIDEO: 'f-video',
    MOVIE: 'f-movie',
    SKY: 'sky',
    PLAYSTATION: 'playstation',
});

export const PARTNER_USING_RECAPTCHA = Object.freeze({
    DELTA: FLOW_TYPE.DELTA,
    WALMARTPLUS: FLOW_TYPE.WALMARTPLUS,
    VERIZON: 'verizon',
    TMOBILE: 'tmobile',
    CBSSPORTS: FLOW_TYPE.CBS_SPORTS,
    SHOWTIME: FLOW_TYPE.SHOWTIME,
    '247SPORTS': FLOW_TYPE.TWENTY_FOUR_SEVEN_SPORTS,
    SPORTSLINE: FLOW_TYPE.SPORTSLINE,
    AMAZON: FLOW_TYPE.AMAZON,
    APPLE: FLOW_TYPE.APPLE,
    PPLUS: 'PPLUS',
});

export const PLAYSTATION_DEVICES = Object.freeze({
    DEVICE_LIST: ['ps4', 'ps5'],
});

export default class FlowModel {
    constructor(obj) {
        this.type = null;
        this.action = null;
        this.activationDeviceFamily = null;
        this.activationPartner = null;
        this.steps = null;
        this.cid = null;
        this.origin_url = null;

        this.forceAnnual = null;
        this.url = null;
        this.destinationUrl = null;
        this.afterSignUpUrl = null;
        this.baseUrl = null;
        this.intcid = null;
        this.rendezvous = null;
        this.partner = null;
        this.isPartnerAuth = false;

        if (typeof obj === 'object') {
            for (let key in obj) {
                if (this.hasOwnProperty(key)) {
                    this[key] = obj.key;
                }
            }
        }
    }

    static isReseller(type) {
        switch (type) {
            case FLOW_TYPE.AMAZON:
            case FLOW_TYPE.WALMARTPLUS:
            case FLOW_TYPE.DELTA:
            case FLOW_TYPE.APPLE:
            case FLOW_TYPE.SHOWTIME:
            case FLOW_TYPE.SPORTSLINE:
            case FLOW_TYPE.TWENTY_FOUR_SEVEN_SPORTS:
            case FLOW_TYPE.FETCH:
                return true;
            default:
                return false;
        }
    }

    static getTypeFromCookie() {
        let graphCookie = getCookie('graph');

        if (graphCookie) {
            try {
                const svod = JSON.parse(graphCookie)?.svod;

                if (!svod) {
                    return null;
                }

                return FlowModel.getTypeFromSvod(svod);
            } catch (e) {}
        }

        return null;
    }

    /**
     * @param svod {string}
     * @returns {string|null}
     */
    static getTypeFromSvod(svod) {
        let flowParams;

        try {
            flowParams = atob(svod);
            const flowType = JSON.parse(flowParams)?.[0];

            if (typeof flowType === 'string') {
                return flowType;
            }
        } catch (e) {
            if (!flowParams) {
                return null;
            }

            let matches = flowParams.match(/a:\d+:{i:\d+;s:\d+:\"([^\"]*)\";/);

            if (matches?.length) {
                return matches[1];
            }
        }

        return null;
    }
}
